import styled from 'styled-components';

export const Box = styled.div<{mt?: number; mb?: number}>`
  margin-top: ${props => props.mt + 'px'};
  margin-bottom: ${props => props.mb + 'px'};
`;
